/* eslint-disable import/prefer-default-export */
/**
 * Adds `value` in between each element of `array`.
 *
 * @param {Array<*>} array
 * @param {unknown} separator
 * @returns {*}
 */
export const intersperse = (array, separator = '•') => array.reduce((acc, key, i) => {
  if (i) acc.push(separator)
  acc.push(key)
  return acc
}, [])

/**
 * Filters an `array` of objects to only have unique items based on `prop`.
 *
 * @param {Array<Object>} array
 * @param {string} prop
 * @returns {Array<Object>}
 */
export const uniqueBy = (array, prop = 'key') => [...new Map(array.map(o => [o?.[prop], o])).values()]

/**
 * Compares the two dates of `a[prop]` and `b[prop]`
 *
 * @param {string} prop
 * @returns {(a: Date, b: Date) => number}
 */
export const date = prop => (a, b) => new Date(b?.[prop]) - new Date(a?.[prop])

/**
 * Adds `value` in between each element of `array`.
 *
 * @param {Array<*>} array
 * @param {((a: any, b: any) => number)?} compareFn
 * @returns {Array<*>}
 */
export const sortBy = (array, compareFn = null) => {
  if (compareFn) {
    return array.sort(compareFn)
  }
  console.warn(`ATTENTION!! Expected compare function, got ${compareFn}, returning unsorted array`)

  return array
}

/**
 * Find the `key` component amongst the `children`.
 *
 * @param {Object[]}           children the children to iterate
 * @param {string} [key='key'] the key to search for
 * @returns {Object|null}      the found object
 */
export const findKey = (children = [{ key: 'key' }], key = 'key') => {
  let found = null

  children.forEach((child) => {
    if (child.key === key) {
      found = child
    } else if (child?.props?.children?.length) {
      found = findKey(child.props.children, key)
    }
  })

  return found
}
